import React, { useState } from 'react';
import styled from 'styled-components/macro';
import Popup from 'components/Popup';
import Slider from 'components/Slider';
import { ImageSlide } from 'components/Slider/Slide';
import ScrollArea from 'components/ScrollArea';

const ThumbnailGallery = ({ images, className }) => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);

    const handleImageClick = (index) => {
        setSelectedImageIndex(index);
        setIsPopupOpen(true);
    };

    const handleClosePopup = () => {
        setIsPopupOpen(false);
    };

    if (!images || images.length === 0) {
        return null;
    }

    return (
        <Container className={className}>
            <GalleryContainer>
                <ScrollArea fadeHeight="6rem" center>
                    <Grid>
                        {images.map((image, index) => (
                            <ThumbnailContainer key={image.id} onClick={() => handleImageClick(index)}>
                                <ThumbnailImage src={image.sizes.medium_large} alt="" />
                            </ThumbnailContainer>
                        ))}
                    </Grid>
                </ScrollArea>
            </GalleryContainer>

            <Popup isOpen={isPopupOpen} onClose={handleClosePopup}>
                <Slider initialSlide={selectedImageIndex} autoplay={false}>
                    {images.map((image) => (
                        <ImageSlide 
                            key={image.id} 
                            image={image} 
                            imageSize="2048x2048" 
                            imageFit="contain"
                        />
                    ))}
                </Slider>
            </Popup>
        </Container>
    );
};

export default ThumbnailGallery;


const Container = styled.div`
    width: 100%;
    height: 100%;
    max-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const GalleryContainer = styled.div`
    flex: 1 1 auto;
    min-height: 0;
    width: 100%;
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 3rem 3rem 6rem;
`;

const Grid = styled.div`
    min-height: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
    justify-content: center;
    align-content: center;
`;

const ThumbnailContainer = styled.div`
    width: 28rem;
    cursor: pointer;
    transition: transform 0.2s ease;
    
    &:hover {
        transform: scale(1.05);
    }
`;

const ThumbnailImage = styled.img`
    width: 100%;
    height: auto;
    display: block;
    object-fit: cover;
    aspect-ratio: 3/2;
`;
